/**
 * Implements a clickable list item
 */
import Text from '../../../atoms/Text';

interface ICard {
  title: string;
  icon: string;
  lock?: boolean;
  additionalClass?: string;
  popupWarning?: boolean;
  onClick(): void;
}

const Card = ({
  title,
  icon,
  lock,
  additionalClass,
  popupWarning,
  onClick,
}: ICard) => {
  return (
    <div
      className={`connect_modal__contents__card ${
        lock ? 'connect_modal__contents__card--lock' : ''
      }`}
      onClick={onClick}
    >
      <img className={`icon ${additionalClass}`} src={icon} />
      <div className='text'>{title}</div>
      {popupWarning && (
        <Text
          size={12}
          className='connect_modal__contents__card__warning text--orange-400'
        >
          Please allow popup window in your browser
        </Text>
      )}
    </div>
  );
};

export default Card;
